var ToastEnum = /* @__PURE__ */ ((ToastEnum2) => {
  ToastEnum2["TOAST_DEFAULT"] = "toast-default";
  ToastEnum2["TOAST_INFO"] = "toast-info";
  ToastEnum2["TOAST_WARN"] = "toast-warn";
  ToastEnum2["TOAST_ERROR"] = "toast-error";
  ToastEnum2["TOAST_SUCCESS"] = "toast-success";
  return ToastEnum2;
})(ToastEnum || {});
export {
  ToastEnum
};
